// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1982S","header":"MergedInvoice_header__2ZSpE"};